export default{
    //get data from local storage
    getLoggedIn : function() {
        localStorage.getItem('isLoggedin')
    },
    getBusinessAccountId : function() {
        return localStorage.getItem('business_account_id')
    },
    getCompanyProfileId : function() {
        return localStorage.getItem('company_profile_id')
    },
    getCompanyEmail : function() {
        return localStorage.getItem('email')
    },
    getSelectedElement : function() {
        return localStorage.getItem('selectElement')
    },
    getRecruiterCompanyName : function() {
        return localStorage.getItem('company_name')
    },
    getSelectedJobId : function() {
        return localStorage.getItem('selectedJobId')
    },
    getmodule : function() {
        return localStorage.getItem('module')
    },
    getRecruiterCompanyprofileId : function() {
        return localStorage.getItem('recruiterCompanyProfileId')
    },
    getRecruiterCompanyBusinessaccountId : function() {
        return localStorage.getItem('recruiterCompanyBusinessAccountId')
    },
    getRecruiterAccountStatus : function() {
        return localStorage.getItem('recruiterAccountStatus')
    },

    //set data to local storage
    setLoggedIn : function(value) {
        localStorage.setItem('isLoggedin', value)
    },
    setBusinessAccountId : function(value) {
        localStorage.setItem('business_account_id', value)
    },
    setCompanyProfileId : function(value) {
        localStorage.setItem('company_profile_id', value)
    },
    setCompanyEmail : function(value) {
        localStorage.setItem('email', value)
    },
    setSelectedElement : function(value) {
        console.log("value : ", value)
        localStorage.setItem('selectElement', value)
    },
    setRecruiterCompanyName : function(value) {
        localStorage.setItem('company_name', value)
    },
    setSelectedJobId : function(value) {
        localStorage.setItem('selectedJobId',value)
    },
    setmodule : function(value) {
        localStorage.setItem('module',value)
    },
    setRecruiterCompanyprofileId : function(value) {
        localStorage.setItem('recruiterCompanyProfileId', value)
    },
    setRecruiterCompanyBusinessaccountId : function(value) {
        localStorage.setItem('recruiterCompanyBusinessAccountId', value)
    },
    setRecruiterAccountStatus : function(value) {
        localStorage.setItem('recruiterAccountStatus', value)
    },
    // setApplyStatus : function(value) {
    //     localStorage.setItem('selectedJobApplyStatus', value)
    // },
    // setActiveElement : function(value) {
    //     localStorage.setItem('activeElement', value)
    // },
    
    // setBusinessAccountId : function(value) {
    //     localStorage.setItem('business_account_id', value)
    // },
    // setCompanyProfileId : function(value) {
    //     localStorage.setItem('company_profile_id', value)
    // },

    // getApplyStatus : function() {
    //     return localStorage.getItem('selectedJobApplyStatus')
    // },
    // getActiveElement : function() {
    //     return localStorage.getItem('activeElement')
    // },
    
    // getBusinessAccountId : function() {
    //     return localStorage.getItem('business_account_id')
    // },
    // getCompanyProfileId : function() {
    //     return localStorage.getItem('company_profile_id')
    // },
}